import { createFileRoute, redirect } from "@tanstack/react-router";

/** Audit moved to its own page at /audit. Keeps old links working. */
export const Route = createFileRoute("/_app/admin/audit/")({
    beforeLoad: ({ location }) => {
        throw redirect({ href: location.href.replace(/^\/admin\/audit/, "/audit"), replace: true });
    },
});
